export default "<div class=\"list\">\r\n    <app-commercial-imputations-list></app-commercial-imputations-list>\r\n</div>\r\n";